import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as Actions from './store/actions';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, Grid } from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
});

class Utils extends Component {
    render() {
        return (
            <div>
                <Grid container spacing={8}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={6}>
                        Make sure to manually truncate gradebook and gradebook_detail
                    </Grid>
                    <Grid item xs={4}>
                        <Button
                            onClick={() => this.props.rebuildGradebook()}
                            disabled={this.props.rebuildGradebookButton.completed}
                            variant={'contained'}
                        >
                            Rebuild Gradebook
                </Button>
                    </Grid>
                </Grid>

            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        rebuildGradebook: Actions.rebuildGradebook
    }, dispatch);
}

function mapStateToProps({ auth, utilReducer }) {
    return {
        auth,
        rebuildGradebookButton: utilReducer.utils.rebuildGradebook
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Utils)));


// WEBPACK FOOTER //
// src/main/content/utils/Utils.js